<template>
  <div class="project-outbox">
    <div class="project">
      <div class="title">平台服务项目</div>
      <div class="pro-info">
        <div class="left">
          <span>项目总数：</span>
          <span>{{ total }}</span>
        </div>
        <div class="right">
          <el-input placeholder="请输入项目名称" prefix-icon="el-icon-search" v-model="search" clearable>
          </el-input>
          <el-button type="primary" class="search" @click="searchHandle">搜索</el-button>
          <el-button type="primary" @click="addProject">新增项目</el-button>
        </div>
      </div>
      <div class="table-box">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column prop="projectCode" label="编号"> </el-table-column>
          <el-table-column prop="projectName" label="项目名称">
          </el-table-column>
          <el-table-column prop="id" label="项目ID"> </el-table-column>
          <el-table-column prop="createTime" label="创建时间">
          </el-table-column>
          <el-table-column prop="personInCharge" label="负责人">
          </el-table-column>
          <el-table-column prop="serviceStartTime" label="服务开始时间"></el-table-column>
          <el-table-column prop="serviceEndTime" label="服务结束时间"></el-table-column>
          <el-table-column prop="edit" label="操作" width="200">
            <template slot-scope="scope">
                  <div class="btn-out-box">
                    <!-- <div
                      class="btn-box download"
                      :class="scope.row.isOpen ? 'active' : ''"
                      @click="downloadHandle(scope)"
                    >
                      <i class="iconfont icon-xiazai"></i>
                    </div> -->
                    <div class="btn-box editself" title="编辑" @click="editselfHandle(scope)">
                      <i class="iconfont icon-bianji1"></i>
                    </div>
                    <el-switch v-model="scope.row.isOpen" @click.native="changeSwitch(scope)" active-color="rgba(31, 207, 138, 1)" inactive-color="rgba(195, 195, 195, 1)">
                    </el-switch>
                  </div>
</template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination-info">
        <div class="left">
          第 {{ currentPage }} 页（共{{ Math.ceil(total / size) }}页），显示{{
            (currentPage - 1) * size + 1
          }}至{{
            currentPage * size >= total ? total : currentPage * size
          }}项结果，共{{ total }}项
        </div>
        <div class="right">
          <el-pagination @size-change="handleSizeChange" @current-change="paginationHandle" :page-sizes="[5, 10, 15, 20]" :page-size="size" layout="total, sizes, prev, pager, next, jumper" :total="total">
          </el-pagination>
        </div>
      </div>
      <!-- <el-pagination
        background
        layout="prev, pager, next"
        :total="total"
        @current-change="paginationHandle"
      >
      </el-pagination> -->
      <el-dialog title="新增项目" :visible.sync="dialogFormVisible" :modal-append-to-body="false">
        <el-form :label-position="'right'" :rules="rules" label-width="120px" ref="ruleForm" :model="form">
          <el-form-item label="项目id：" prop="id">
            <el-input v-model="form.id" @input="changeInput"></el-input>
          </el-form-item>
          <el-form-item label="项目编号：" prop="projectCode">
            <el-input v-model.trim="form.projectCode" ></el-input>
          </el-form-item>
          <el-form-item label="项目名称：" prop="projectName">
            <el-input v-model.trim="form.projectName"></el-input>
          </el-form-item>
          <el-form-item label="负责人：" prop="personInCharge">
            <el-input v-model.trim="form.personInCharge"></el-input>
          </el-form-item>
          <el-form-item label="联系电话：" prop="concatNumber">
            <el-input v-model.trim="form.concatNumber"></el-input>
          </el-form-item>
          <el-form-item label="服务起止日期：">
            <el-col :span="11">
              <el-form-item prop="serviceStartTime">
                <el-date-picker type="date" placeholder="选择日期" v-model="form.serviceStartTime" value-format="yyyy-MM-dd" style="width: 100%"></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col class="line" :span="2">~</el-col>
            <el-col :span="11">
              <el-form-item prop="serviceEndTime">
                <el-date-picker type="date" placeholder="选择日期" value-format="yyyy-MM-dd" v-model="form.serviceEndTime" style="width: 100%"></el-date-picker>
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-form-item label="装机容量：" prop="installedCapacity">
            <el-input v-model.trim="form.installedCapacity">
<template slot="append">
   kVA
</template>
            </el-input>
            <!-- <el-input v-model="form.installedCapacity"></el-input> -->
          </el-form-item>
          <el-form-item label="申报需量：" prop="declareCapacity">
            <el-input v-model.trim="form.declareCapacity">
<template slot="append">
   kWh
</template>
            </el-input>
          </el-form-item>
          <el-form-item label="电压等级：" prop="voltageLevel">
            <el-input v-model.trim="form.voltageLevel">
<template slot="append">
   kV
</template>
            </el-input>
          </el-form-item>
          <!-- <el-form-item label="项目封面图标链接：">
            <el-input v-model="form.projectIcon"></el-input>
          </el-form-item> -->
          <!-- <el-form-item label="topic：">
            <el-input v-model="form.topic"></el-input>
          </el-form-item> -->
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="addProjectHandle">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>

import {
  Message
} from 'element-ui';
  export default {
    data() {
      return {
        value: false,
        search: "",
        tableData: [],
        dialogFormVisible: false,
        form: {
          id: "",
          serviceStartTime: "",
          serviceEndTime: "",
          concatNumber: "",
          declareCapacity: "",
          installedCapacity: "",
          personInCharge: "",
          projectCode: "",
          projectIcon: "",
          projectName: "",
          voltageLevel: "",
          // topic: "",
        },
        rules: {
          id: [{
            required: true,
            message: "请填写此项内容",
            trigger: "blur"
          }],
          serviceStartTime: [{
            required: true,
            message: "请填写此项内容",
            trigger: "blur"
          }, ],
          serviceEndTime: [{
            required: true,
            message: "请填写此项内容",
            trigger: "blur"
          }, ],
          concatNumber: [{
            required: true,
            message: "请填写此项内容",
            trigger: "blur"
          }, ],
          declareCapacity: [{
            required: true,
            message: "请填写此项内容",
            trigger: "blur"
          }, ],
          installedCapacity: [{
            required: true,
            message: "请填写此项内容",
            trigger: "blur"
          }, ],
          personInCharge: [{
            required: true,
            message: "请填写此项内容",
            trigger: "blur"
          }, ],
          projectCode: [{
            required: true,
            message: "请填写此项内容",
            trigger: "blur"
          }, ],
          projectIcon: [{
            required: true,
            message: "请填写此项内容",
            trigger: "blur"
          }, ],
          projectName: [{
            required: true,
            message: "请填写此项内容",
            trigger: "blur"
          }, ],
          voltageLevel: [{
            required: true,
            message: "请填写此项内容",
            trigger: "blur"
          }, ],
        },
        currentPage: 1,
        size: 10,
        total: 0,
      };
    },
    created() {
      this.getData();
    },
    methods: {
      getData() {
        this.$http
          .post("bma-user-service/project/searchProjectList", {
            currentPage: this.currentPage,
            projectName: this.search,
            size: this.size,
          })
          .then((res) => {
            let list = res.data.records;
            list.forEach((element) => {
              if (element.status == 1) {
                element.isOpen = true;
              } else {
                element.isOpen = false;
              }
            });
            this.total = res.data.total;
            this.tableData = res.data.records;
          });
      },
      changeInput() {
        var pattern = /^[1-9][0-9]*$/; // 正整数的正则表达式
        // 不符合正整数时
        if (!pattern.test(this.form.id)) {
          // input 框绑定的内容为空
          this.form.id = "";
        }
      },
      changeSwitch(scope) {
        let status = Number(scope.row.isOpen);
        this.$confirm(
            "确认" + (status === 1 ? "开启" : "关闭") + "此项目?",
            "提示", {
              confirmButtonText: "确认",
              cancelButtonText: "取消",
              type: "warning",
            }
          )
          .then(() => {
            this.sendState(status, scope);
          })
          .catch(() => {
            this.getData();
          });
      },
      sendState(status, scope) {
        this.$http
          .post("bma-user-service/project/updateProjectStatus", {
            projectId: scope.row.id,
            projectStatus: status,
          })
          .then((res) => {
            Message.successs("修改成功");
            this.getData();
          });
      },
      downloadHandle(scope) {
        console.log(scope);
      },
      editselfHandle(scope) {
        if (!scope.row.isOpen) return;
        let id = scope.row.id;
        document.cookie = "projectName=" + scope.row.projectName;
        this.$router.push({
          path: `/super/info/${id}`,
        });
      },
      handleSizeChange(e) {
        this.currentPage = 1;
        this.size = e;
        this.getData();
      },
      paginationHandle(index) {
        this.currentPage = index;
        this.getData();
      },
      addProject() {
        this.dialogFormVisible = true;
        this.form = {};
      },
      addProjectHandle() {
        let isRight = true;
        this.$refs["ruleForm"].validate((valid) => {
          if (!valid) {
            console.log("error submit!!");
            isRight = false;
            return false;
          }
        });
        if (!isRight) {
          return;
        }
        this.form.dataType = "1";
        this.$http
          .post("bma-user-service/project/addProject", this.form)
          .then((res) => {
            let that = this
            if (res.code == 200) {
              that.initV(res.data);
              Message.success("新增成功");
            }
            that.dialogFormVisible = false;
            that.getData();
          });
      },
      // 初始化项目电价
      initV(id) {
        this.$http
          .post(
            "bma-distribution-service/electricPrice/initProjectElectricPrice", {
              projectId: id,
            }
          )
          .then((res) => {
            console.log("电价", res);
          });
      },
      searchHandle() {
        this.currentPage = 1;
        this.getData();
      },
    },
    watch: {
      search(v) {
        if (!v) {
          this.getData();
        }
      },
    },
  };
</script>

<style lang="less" scoped>
  .project-outbox {
    padding: 20px;
  }
  .project {
    background: #f8f8f9;
    border-radius: 7px;
    padding: 24px;
    .title {
      font-size: 18px;
      color: #0e223d;
      letter-spacing: 2px;
      font-weight: 600;
      text-align: left;
    }
    .pro-info {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 30px;
      margin-bottom: 28px;
      position: relative;
      z-index: 2000;
      .left {
        font-size: 16px;
        color: #0e223d;
        span {
          &:last-of-type {
            font-weight: 600;
          }
        }
      }
      .right {
        display: flex;
        .el-input {
          margin-right: 10px;
        }
        .search {
          margin-right: 20px;
        }
      }
    }
    .table-box {
      /deep/.el-table {
        background: rgba(0, 0, 0, 0);
        th,
        tr {
          background: rgba(0, 0, 0, 0);
        }
        th {
          >.cell {
            color: #152139;
            font-size: 14px;
            font-weight: 600;
            text-align: center;
          }
        }
        tr {
          td {
            text-align: center;
            font-size: 14px;
            color: #152139;
          }
        }
        .btn-out-box {
          display: flex;
          justify-content: space-around;
        }
        .btn-box {
          width: 24px;
          height: 24px;
          background: rgba(165, 165, 165, 0.1);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          .iconfont {
            font-size: 12px;
            color: rgba(195, 195, 195, 1);
          }
          &.download.active {
            background: rgba(31, 207, 138, 0.1);
            .iconfont {
              color: rgba(31, 207, 138, 1);
            }
          }
          &.editself:hover {
            background: rgba(20, 96, 224, 0.1);
            .iconfont {
              color: rgba(20, 96, 224, 1);
            }
          }
        }
      }
      .el-switch {
        transform-origin: center;
        transform: scale(0.7);
      }
    }
    .pagination-info {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 10px;
      .left {
        font-size: 12px;
        color: rgba(137, 146, 159, 1);
      }
    }
    .el-pagination {
      text-align: center;
      margin-top: 30px;
    }
    .el-dialog {
      width: 35%;
      .el-dialog__title {
        font-weight: 600;
      }
      .el-input {
        // width: 323px;
      }
      .line {
        text-align: center;
      }
    }
  }
</style>
